import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export interface AddressDef {
  fields: string[];
  validationSchema: any;
  // add more fields based on what's returned
}

export const addressDef = () => {
  return {
    mutation: MY_HR_CREATE_CHANGE_REQUEST,
    items: [
      {
        label: "OC_VALIDITY",
        name: "validFrom",
        type: "datePicker",
        validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
      },
      {
        label: "MY_HR_COUNTRY",
        name: "country",
        dataField: "country",
        type: "country",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_COUNTRY",
        name: "addressSelector",
        type: "addressSelector",
      },
      {
        label: "MY_HR_ZIP",
        name: "zip",
        dataField: "zip",
        type: "postalCodeSelector",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_CITY",
        name: "city",
        dataField: "city",
        type: "postalCodeSelector",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_DISTRICT",
        name: "district",
        dataField: "district",
        type: "districtCode",
        validation: Yup.string().matches(/^\d{2}$/, "OC_INCORRECT_FORMAT"),
      },
      {
        label: "MY_HR_STREETNAME",
        name: "streetName",
        dataField: "streetName",
        type: "text",
        validation: Yup.string()
          .trim()
          .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
      },
      {
        label: "MY_HR_STREETTYPE",
        name: "streetType",
        dataField: "streetType",
        type: "streetType",
        validation: Yup.mixed().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
      },
      {
        label: "MY_HR_STREETNUMBER",
        name: "streetNumber",
        dataField: "streetNumber",
        type: "text",
        validation: Yup.string()
          .trim()
          .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
      },
      {
        label: "MY_HR_BUILDING",
        name: "building",
        dataField: "building",
        type: "text",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_STAIRWAY",
        name: "stairway",
        dataField: "stairway",
        type: "text",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_FLOOR",
        name: "floor",
        dataField: "floor",
        type: "text",
        validation: Yup.string(),
      },
      {
        label: "MY_HR_DOOR",
        name: "door",
        dataField: "door",
        type: "text",
        validation: Yup.string(),
      },
      {
        label: "OC_MESSAGE",
        name: "initialMessage",
        type: "textarea",
        validation: Yup.string(),
      },
    ],
  };
};
